import React, { useState, useEffect, useRef } from "react";
import ModalCliente from '../clientes/ClienteModal';
import ClienteNuevo from "../clientes/ClientesNuevo";
import Modal from "../Modal";
import ModalBuscarCliente from "../Preventas/ModalBuscarCliente";
import { defaultGetHeaders, pfetch } from "../../helpers/wrappers";
import Notify from "../Notify";

const ClientSelector = ({ onSelectClient }) => {
    const [showAddClient, setShowAddClient] = useState(false);
    const [showSearchClient, setShowSearchClient] = useState(false);
    const [doc, setDoc] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const inputRef = useRef(null);

    const handleSelectClient = (c) => {
        setShowAddClient(false);
        setShowSearchClient(false);
        
        let cli = { ...c };
        if (Object.keys(cli).length) {
            setSelectedClient(cli);
            
            const docNum = cli.NroTipoDocumento || cli.NumeroDocumento || "";
            const name = cli.RazonSocial || cli.Nombre || "";
            
            const displayText = docNum && name ? `${docNum} - ${name}` : (docNum || name);
            
            setDoc(displayText);
            if (onSelectClient) {
                onSelectClient(cli);
            }
        }
    };

    const fetchClient = (val) => {
        pfetch({
            fetch: {
                url: `/api/preVentas/traerCliente/${val}`,
                method: "GET",
                headers: defaultGetHeaders()
            },
            before: () => setIsLoading(true),
            then: (d) => {
                if (d && d.length > 0) {
                    handleSelectClient(d[0]);
                } else {
                    Notify("No se encontró al cliente", "error");
                }
            },
            error: () => Notify("No se pudo buscar al cliente", "error"),
            finally: () => setIsLoading(false)
        });
    };

    const handleSearchChange = (e) => {
        const val = e.target.value;
        setDoc(val);
        
        if (selectedClient) {
            setSelectedClient(null);
            if (onSelectClient) {
                onSelectClient(null);
            }
        }

        if (val.length === 8 || val.length === 11) {
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }, 150);
            fetchClient(val);
        }
    };

    return (
        <>
            <div className="form-group-custom" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                    id="docClienteEmitir"
                    ref={inputRef}
                    type="text"
                    className="form-input-custom"
                    placeholder="DNI/RUC"
                    value={doc}
                    onChange={handleSearchChange}
                    disabled={isLoading}
                    style={{ 
                        paddingRight: '85px',
                        borderColor: selectedClient ? '#28a745' : '#009688',
                        backgroundColor: selectedClient ? '#f0fff4' : 'white',
                        fontWeight: selectedClient ? '600' : 'normal',
                        transition: 'all 0.3s ease'
                    }}
                />
                <div style={{ position: 'absolute', right: '15px', display: 'flex', gap: '12px', alignItems: 'center' }}>
                    {selectedClient && (
                        <i className="fas fa-check-circle" style={{ color: '#28a745', fontSize: '1.1rem' }}></i>
                    )}
                    <button 
                        type="button"
                        onClick={() => setShowSearchClient(true)}
                        title="Buscar cliente en la lista"
                        disabled={isLoading}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#009688', padding: 0, fontSize: '1.2rem' }}
                    >
                        <i className="fas fa-search"></i>
                    </button>
                    <button 
                        type="button"
                        onClick={() => setShowAddClient(true)}
                        title="Nuevo cliente"
                        disabled={isLoading}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#009688', padding: 0, fontSize: '1.2rem' }}
                    >
                        <i className="fas fa-user-plus"></i>
                    </button>
                </div>
            </div>

            <ModalCliente 
                isOpen={showAddClient}
                onClose={() => setShowAddClient(false)}
                title="NUEVO CLIENTE"
            >
                <ClienteNuevo 
                    onClose={() => setShowAddClient(false)}
                    AsignarValorDoc={handleSelectClient}
                />
            </ModalCliente>

            <Modal 
                title="BUSCAR CLIENTE" 
                isOpen={showSearchClient}
                onClose={() => setShowSearchClient(false)}
            >
                <ModalBuscarCliente
                    GetCliente={handleSelectClient}
                />
            </Modal>
        </>
    );
};

export default ClientSelector;